import { render } from "./OnInputList.vue?vue&type=template&id=54f3d820&scoped=true&ts=true"
import script from "./OnInputList.vue?vue&type=script&lang=ts"
export * from "./OnInputList.vue?vue&type=script&lang=ts"

import "./OnInputList.vue?vue&type=style&index=0&id=54f3d820&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f3d820"]])

export default __exports__